export default "__VITE_ASSET__DCPEgWAq__"